import React from "react";
import { motion } from "framer-motion";

export default function LayoutLoginHomepage({ children }) {
  return (
    <div className="relative h-screen w-full overflow-hidden" style={{ height: "100dvh", maxHeight: "100dvh" }}>
      {/* Static background layer */}
      <div 
        className="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black -z-10"
        aria-hidden="true"
      />
      
      {/* Content */}
      <motion.div
        className="relative h-full text-white w-full overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </div>
  );
}